<footer class="footer">
  <ods-link class="footer__link" href="https://www.upmchealthplan.com/legal/font" target="_blank">Font Attribution</ods-link>
  @if (hasAlfred) {
    <ods-link class="footer__link" routerLink="alfred">
      <span>Alfred</span>
    </ods-link>
  }
</footer>
